import { Plugin } from '@nuxt/types';
import RouteEnum from '~/enums/RouteEnum';

declare module 'vue/types/vue' {
  interface Vue {
    $RouteEnum: typeof RouteEnum;
  }
}

declare module '@nuxt/types' {
  interface NuxtAppOptions {
    $RouteEnum: typeof RouteEnum;
  }
  interface Context {
    $RouteEnum: typeof RouteEnum;
  }
}

const routeEnumPlugin: Plugin = (_context, inject) => {
  inject('RouteEnum', RouteEnum);
};

export default routeEnumPlugin;
